export default () => {
    addEventListener('ajax:promise', function(event) {
        event.target.closest('form').querySelectorAll('[data-attach-loading-disable]').forEach(function(el) {
            el.disabled = true;
        });
    });

    addEventListener('ajax:always', function() {
        event.target.closest('form').querySelectorAll('[data-attach-loading-disable]').forEach(function(el) {
            el.disabled = false;
        });
    });
}
